import { InitOptionsJSON } from '@acsbe/widget-settings';
import { validate } from '../pages/root/customization/widgetSettings';
import axios from './../utils/axiosInstance';

export const repairWidgetConfig = (
  widgetConfig: Partial<InitOptionsJSON>,
  metadata: { domain: string },
) => {
  const validationResult = validate(widgetConfig);

  if (validationResult.invalidKeys && validationResult.invalidKeys.length > 0) {
    if (validationResult.invalidKeys.indexOf('footerHtml') !== -1) {
      if (!widgetConfig.footerHtml) {
        delete widgetConfig.footerHtml;
      }
      validationResult.invalidKeys = validationResult.invalidKeys.filter(
        (key) => key !== 'footerHtml',
      );
    }
  }
  if (validationResult.invalidKeys && validationResult.invalidKeys.length > 0) {
    // Send the validation result to the server
    axios.post(`/api/accessibe/widget-config-validation`, {
      widgetConfig,
      validationResult,
      metadata,
    });
  }
  return widgetConfig;
};
